import React, { useMemo } from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import TableContainer from "components/Common/TableContainer"
import { usePermission } from "hooks/usePermission"
import { PERMISSIONS } from "helpers/roles"
import { formatAmount, getTableSortingHeaderIcon } from "helpers/common"
import { useSelector } from "react-redux"
import moment from "moment"

const IcdPaymentsParts = ({ data, close, open }) => {
  const { userType } = useSelector((state) => state.user)
  const { hasPermission } = usePermission()

  const getStatus = (key) => {
    let status = "Active"
    let className = "Active"

    switch (key) {
      case "PENDING":
        status = "Pending"
        className = "under_review"
        break

      case "FAILED":
        status = "Failed"
        className = "rejected"
        break

      default:
        status = "Approved"
        className = "approved"
        break
    }

    return (
      <div className={`badge ${className}`}>
        <span></span> {status}
      </div>
    )
  }

  const columns = useMemo(() => {
    const data = [
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Date"),
        accessorKey: "date_of_payment",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <>{moment(row?.original.date_of_payment).format("D MMM YYYY")}</>
        ),
      },
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Amount (₹)"),
        accessorKey: "amount",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => <div>₹ {formatAmount(row?.original?.amount)}</div>,
      },
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, "Payment Mode"),
        accessorKey: "payment_mode",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => <>{row?.original?.payment_type}</>,
      },
      {
        header: "Payment ID",
        accessorKey: "itr",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => (
          <div className="code-status">
            {row?.original?.utr_no || row?.original?.order_id}
          </div>
        ),
      },
      {
        header: () => <div className="flex items-center gap-2">Status</div>,
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => (
          <div className="code-status">{getStatus(row?.original?.status)}</div>
        ),
      },
    ]

    const canAccess = hasPermission(PERMISSIONS.ICD_VIEW)

    let result = canAccess ? data : data.filter((item) => item.id !== "actions")

    if (userType === "INVESTOR") {
      result = result.filter((item) => item.accessorKey !== "name")
    }

    return result
  }, [hasPermission])

  return (
    <Modal
      isOpen={open}
      toggle={() => {
        close()
      }}
      size="lg"
      centered={true}
    >
      <ModalHeader
        toggle={() => {
          close()
        }}
      >
        Payments
      </ModalHeader>
      <ModalBody>
        <TableContainer
          //   isLoading={isFetching}
          count={data.length}
          filters={{ page: 1, pageSize: 500 }}
          // setFilters={setFilters}
          columns={columns}
          data={data}
          //   isGlobalFilter={true}
          //   isCustomPageSize={true}

          // isGlobalFilter={true}
          isPagination={false}
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      </ModalBody>
    </Modal>
  )
}

export default IcdPaymentsParts
